import { Controller } from "@hotwired/stimulus"

// A labelled show/hide panel. Keeps aria-expanded in sync so the control is
// meaningful to screen readers, and swaps the trigger label.
export default class extends Controller {
  static targets = ["panel", "label"]
  static values = { openLabel: String, closedLabel: String }

  toggle() {
    const open = this.panelTarget.hidden
    this.panelTarget.hidden = !open
    this.element.querySelector("[data-action~='disclosure#toggle']")
      ?.setAttribute("aria-expanded", String(open))

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = open ? this.openLabelValue : this.closedLabelValue
    }
  }
}
